// extracted by mini-css-extract-plugin
export default {"brandPromo":"pI-z","carousel":"qI-z"};